<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div v-loading="loading">
      <div class="button_wrap">
        <span
          ><h4>{{ language("shopCampaign.breadcrumbTitle") }}</h4></span
        >
        <template v-if="$menuList['SIS-ShopDisplay-Campaign-Add']">
          <el-button type="primary" @click="open">{{
            language("shopCampaign.add")
          }}</el-button>
        </template>
      </div>
      <el-divider></el-divider>
      <div class="count_tips">
        <div>
          {{ language("shopCampaign.results") }} {{ results }}
          {{ language("shopCampaign.rows") }}
        </div>
        <page :total="results" @pageChange="pageChange"></page>
      </div>
      <cc-table
        :loadData="false"
        :dataArr="dataArr"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        :showIndex="false"
        :buttonsWidth="buttonsWidth"
        :emptyText="language('shopCampaign.emptyText')"
      ></cc-table>
    </div>

    <template v-if="dialog">
      <el-dialog
        :title="language('shopCampaign.breadcrumbTitle')"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        width="80%"
      >
        <campaign-edit @success="success" :editData="editData"></campaign-edit>
      </el-dialog>
    </template>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import campaignEdit from "./components/campaignEdit";
import page from "../../components/page";

export default {
  components: {
    breadcrumb,
    campaignEdit,
    page,
  },
  data() {
    return {
      loading: true,
      breadcrumb: {
        title: this.language("shopCampaign.breadcrumbTitle"),
        list: [
          {
            name: this.language("shopCampaign.breadcrumbList_1"),
          },
          {
            name: this.language("shopCampaign.breadcrumbList_2"),
          },
        ],
      },
      table: {
        api: "admin/merchant/tag/query",
        showPager: false,
        columns: [
          // {
          //   prop: "id",
          //   lable: "ID",
          // },
          {
            prop: "sort",
            lable: this.language("shopCampaign.sort"),
            minWidth: 80,
          },

          {
            prop: "name",
            lable: this.language("shopCampaign.nameChi"),
            minWidth: 150,
          },
          {
            prop: "nameEn",
            lable: this.language("shopCampaign.nameEng"),
            minWidth: 150,
          },
          {
            prop: "code",
            lable: this.language("shopCampaign.code"),
            minWidth: 50,
          },
          // {
          //   prop: "parentId",
          //   lable: this.language("shopCampaign.parentId"),
          // },

          {
            prop: "isShow",
            lable: this.language("shopCampaign.isShow"),
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("shopCategory.visible"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopCategory.invisible"),
              },
            },
          },

          {
            prop: "status",
            lable: this.language("shopCampaign.displayed"),
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("shopCampaign.visible"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopCampaign.invisible"),
              },
              2: {
                tagType: "danger",
                text: this.language("shopCampaign.forbidden"),
              },
            },
          },
        ],
        buttons: [],
      },
      params: {},
      refeshTable: -1,
      dialog: false,
      editData: {},
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      dataArr: [],
      results: 0,
      buttonsWidth: 0,
    };
  },
  methods: {
    open() {
      this.editData = {};
      this.dialog = true;
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    getData(e) {
      e.shopNum = this.$shopData.shopNum;
      e.mchShopNum = this.$shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/tag/query", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;

          this.$message.error(err.response.data.message);
        });
    },
    success() {
      // this.dialog = false;
      this.getData(this.form);
    },
    delete(row) {
      this.$confirm(
        this.language("common.deletePermanentTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do(
              "admin/merchant/tag/batchDelete",
              {
                ids: [row.id],
              },
              "POSTJSON"
            )
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopBannerForm.success"),
              });
              this.getData(this.form);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
    if (this.$menuList["SIS-ShopDisplay-Campaign-Edit"]) {
      this.table.buttons.push({
        name: this.language("shopCampaign.edit"),
        click: (row, index) => {
          this.editData = { ...row };
          this.dialog = true;
        },
      });
      this.buttonsWidth = 80;
    }
    if (this.$menuList["SIS-ShopDisplay-Campaign-Delete"]) {
      this.table.buttons.push({
        name: this.language("shopCampaign.delete"),
        click: (row, index) => {
          this.delete(row);
        },
      });
      this.buttonsWidth = 80;
    }
  },
};
</script>
<style >
</style>
<style scoped lang="scss">
.button_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.count_tips {
  margin: 10px 0 20px 0;
  display: flex;
  justify-content: space-between;
  // font-size: $sbuTitle;
  font-weight: 600;
}
</style>